module.exports = __webpack_public_path__ + "static/img/weixuanzhongtupian.png@2x.ef45a2df.png";